<template>
  <div class="MobileIndexPage">
    <div class="homePageContainer" @click="showMenu=false">
      <div class="header">
        <div class="logo">
          <img src="/logo.png">
        </div>
        <div class="flexDiv">
          <div class="menu" @click.stop="showMenu=true">
            <img src="https://seaweedfs.thumpai.cn/7,040ebbd4428f.png" alt="">
            <span v-show="activeIndex<3">{{menuList[0]}}</span>
            <span v-show="activeIndex>2">{{menuList[activeIndex-2]}}</span>
          </div>
        </div>

      </div>
      <div class="CarouselContainer">
        <div ref="mySwiper" class="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="sliderPage">
                <div class="textBody">
                  <div class="title">产品由来</div>
                  <div class="content">
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;AI全效输入法、单位浏览器、搜索等软件是该操作系统办公平台里的终端功能模块，借助国产内核、引擎的边缘协同隐私计算、对等网络、人工智能等自主可控的技术手段让个人和办公写作更安全、更高效。
                  </div>
                </div>
                <div class="imageBody"><img v-lazy="'/certificate.png'" alt=""></div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="sliderPage">
                <div class="textBody">
                  <div class="title1">主打亮点</div>
                  <div class="title">更安全</div>
                  <div class="content">可快速私有化部署服务端的输入法，办公、写作、沟通等场景的输入行为数据、内容数据都完全私有化，保障信息安全，协助创建机构自有的知识图谱和人工智能引擎。</div>
                  <div class="title" style="margin-top: 20px">更效率</div>
                  <div class="content">除智能关联提示候选词，还能自动检索本机文库、单位文库和订阅文库，推送候选句子和文章，帮助您在办公、写作场景下更快速、更高效的打字、拟文办公，提高效率和引用规范。
                    专注提升办公写作等特定场景的安全和效率。
                  </div>
                </div>
                <div class="imageBody"><img :src="'https://seaweedfs.thumpai.cn/4,03f50a268a9a.png'" alt=""></div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="sliderPage">
                <div class="imageBody"><img :src="'https://seaweedfs.thumpai.cn/1,03f6a7703776.png'" alt=""></div>
                <div class="textBody">
                  <div class="title">纯净无广告弹窗</div>
                  <div class="content">无广告，不骚扰；不存储用户隐私数据；界面简约清爽，程序敏捷；</div>
                  <div class="title" style="margin-top: 20px">极致专注</div>
                  <div class="content">去除冗余功能，专注产品核心；页面简约清爽，输入极致体验；快捷操作，专注正事；</div>
                  <div class="title" style="margin-top: 20px">支持定制高性价比</div>
                  <div class="content">可为机构客户定制专属LOGO和词库，快速部署；按需合作定制专属文库，享受独特尊贵服务；计费模式多样，高性价比；</div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="sliderPagePersonal">
                <div class="title2">独特功能</div>
                <div class="pageContentItem">
                  <div class="personalImage"><img src="/current.png" alt=""></div>
                  <div class="personalText">
                    <div class="title">设置<span>本机文库</span></div>
                    <div class="content">写作输入过程中自动检索各类文库中的关联文章，整段或多段文字一键输入。</div>
                  </div>
                </div>
                <div class="pageContentItem" style="margin-top:20px;">
                  <div class="personalImage"><img src="/jiansuo.png" alt=""></div>
                  <div class="personalText">
                    <div class="title">高效检索输入</div>
                    <div class="content">
                      <img src="https://seaweedfs.thumpai.cn/2,0409e8216287.png" alt=""> 具有<span>▼</span>的候选词，可Ctrl+编号数字
                      或Tab键检索各类文库的关联文章
                      <br/><img src="https://seaweedfs.thumpai.cn/2,0409e8216287.png" alt=""> 左右键 或 -= 进行翻页查看
                      <br/><img src="https://seaweedfs.thumpai.cn/2,0409e8216287.png" alt=""> 点击左侧编号字母则句子直接输入
                      <br/><img src="https://seaweedfs.thumpai.cn/2,0409e8216287.png" alt=""> 点击右侧编号字母则展开正文
                      <br/><img src="https://seaweedfs.thumpai.cn/2,0409e8216287.png" alt=""> Shift+上下键可选择多段
                      <br/><img src="https://seaweedfs.thumpai.cn/2,0409e8216287.png" alt=""> 按空格键多段输入
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="sliderPage">
                <div class="title2">独特功能</div>
                <div class="imageBody"><img :src="'https://seaweedfs.thumpai.cn/1,03f7c4aa55c4.jpg'" alt=""></div>
                <div class="textBody">
                  <div class="title">自建单位文库</div>
                  <div class="content">&nbsp;&nbsp;&nbsp;&nbsp;企业可以通过后台，上传公司内部产品资料、价格表单、政策文件等内容，员工可通过输入法快速插入相关内容，从而提高整体的工作效率。
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;拟文过程中参考文档、法规等引用更便利，比搜索外网获取的内容更可靠。
                    <br/>&nbsp;&nbsp;&nbsp;&nbsp;可与客户单位原有网盘、邮件等文库系统打通，在写作过程中自动协助寻找相关参考文档。
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="sliderPage">
                <div class="textBody">
                  <div class="title">个人用户版</div>
                  <div class="content">请您复制并转发下载链接到电脑安装使用</div>
                  <div class="button" style="background-color: dodgerblue"
                       @click="copyText('https://www.aimofn.com/')"><img
                      src="https://seaweedfs.thumpai.cn/7,040514b663d4.png" alt="">
                    <span class="btn_down">Windows版</span>
                    <div class="icon">
                      点击复制
                    </div>
                  </div>
                  <div class="button" style="background-color: rgb(90, 191, 222)" @click="copyText('https://www.aimofn.com/')">
                    <img src="https://seaweedfs.thumpai.cn/6,04061a6c9d42.png" alt=""><span class="btn_down">MAC版</span>
                    <div class="icon">
                      点击复制
                    </div>
                  </div>
                  <div class="button" style="background-color: rgb(91,183,91)"
                       @click="copyText('https://www.aimofn.com/')"><img
                      src="https://seaweedfs.thumpai.cn/6,0407a9301550.png" alt="">
                    <span class="btn_down">Linux统信版</span>
                    <div class="icon">
                      点击复制
                    </div>
                  </div>
                  <div class="title">机构客户版</div>
                  <div class="content">免费申请试用</div>
                  <div class="button" style="background-color: rgb(240,173,77)" @click="dialogShowFn">
                    <img src="https://seaweedfs.thumpai.cn/7,0408c99a1da2.png" alt="">
                    <span>立即申请</span>
                  </div>
                </div>
                <div class="dialog" v-show="dialogShow">
                  <div class="dialogBody">
                    <div class="textBody">
                      <div class="title" style="font-size: 24px">AI全效输入法<br/>机构客户版免费申请</div>
                      <div class="content">安装并登录左侧个人用户版输入法后，<br/>在"设置"→"交流"模块中进行留言申请，<br/>期待与您达成合作。
                      </div>
                    </div>
                    <div class="imageBody" style="margin-top: 20px"></div>
                    <div style="text-align:center;line-height: 80px;font-size: 14px;color: #868686;user-select: none"><a href="https://www.aimofn.com/">请访问我们的官网，获取最新版本下载地址</a></div>
                    <div class="closeButton" @click="dialogShow=false"><img
                        src="https://seaweedfs.thumpai.cn/6,0415ccb31e48.png" alt=""></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="swiper-slide">
              <div class="sliderPageUs sliderPage">
                <div class="textBody">
                  <div class="title">联系方式</div>
                  <div style="margin:30px 0;font-size: 16px;display: flex;flex-direction: column;gap: 10px">
                    <span>尹老师：13811587758</span>
                    <span>座机：010-80696969</span>
                    <span>邮箱：800414@qq.com</span>
                  </div>
                  <img src="/product.png" style="width:70vw;margin: 0 auto;">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="navTabList" v-show="showMenu">
        <div :class="{'navTabItem':true,'navTabItemActive':activeIndex<3}" @click="goToPage(0)">AI全效输入法</div>
        <div style="padding-left: 30px;box-sizing: border-box;position: relative">
          <div style="border-left: 1px solid #909090;">
            <div :class="{'navTabItem':true,'navTabItemSecond':true,'navTabItemActive':activeIndex===3}"
                 @click="goToPage(3)"><span :style="{color: activeIndex===3?'#fff':'#909090'}">——</span> 个人版
            </div>
            <div :class="{'navTabItem':true,'navTabItemSecond':true,'navTabItemActive':activeIndex===4}"
                 @click="goToPage(4)"><span :style="{color: activeIndex===4?'#fff':'#909090'}">——</span> 企业版
            </div>
            <div :class="{'navTabItem':true,'navTabItemSecond':true,'navTabItemActive':activeIndex===5}"
                 @click="goToPage(5)"><span :style="{color: activeIndex===5?'#fff':'#909090'}">——</span> 下载
            </div>
          </div>
        </div>
        <div :class="{'navTabItem':true,}" @click="goHome()">反馈</div>
        <div :class="{'navTabItem':true,'navTabItemActive':activeIndex===6}" @click="goToPage(6)">联系我们</div>
      </div>
      <div class="guide" v-show="activeIndex<6" @click="goToPage(activeIndex+1)">
        <img src="https://seaweedfs.thumpai.cn/5,03f8dd25c415.svg" alt=""></div>
      <div class="returnTop" v-show="activeIndex>0" @click="goToPage(0)">
        <img src="https://seaweedfs.thumpai.cn/5,040c1d3fb4d3.png" alt=""></div>
      <div class="messageDialog" v-show="messageShow">恭喜您复制成功:-)<br/><span>粘贴到聊天软件发送给电脑端</span></div>
      <div class="pageBottomBody" v-show="activeIndex===5">
        <div class="footer">
          <p>备案序号：<a href="https://beian.miit.gov.cn" target="_blank">京ICP备 20014158号-4</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/css/swiper.css';

  export default {
    name: "MobileIndexPage",
    mounted() {
      this.initSwiper();
    },
    methods: {
      initSwiper() {
        let that = this;
        this.currentSwiper = new Swiper('.swiper', {
          speed: 400,
          spaceBetween: 0,
          direction: 'vertical',
          mousewheel: true,
          pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true,
            clickable: true,
          },
          on: {
            slideChangeTransitionEnd: function () {
              that.activeIndex = this.activeIndex;
            }
          }
        })
      },
      copyText(text) {
        let input = document.createElement('input');
        input.setAttribute('readonly', 'rendonly');
        input.setAttribute('value', text);
        document.body.appendChild(input);
        input.setSelectionRange(0, 9999);
        input.select();
        if (document.execCommand('copy')) {
          document.execCommand('copy');
        }
        document.body.removeAttribute(input);
        this.messageShow = true;
        setTimeout(() => {
          this.messageShow = false;
        }, 2000)
      },
      goHome(){
        window.open('https://www.aimofn.com/');
      },
      goToPage(index) {
        this.activeIndex = index;
        this.currentSwiper.slideTo(index, 400, false)
      },
      jumpPage(type) {
        let url = type === 0 ? 'http://www.thupdi.com' : 'http://www.bjchengshikeji.com'
        window.open(url)
      },
      dialogShowFn() {
        this.dialogShow = true;
        setTimeout(() => {
          this.dialogShow = false;
        }, 6000)
      }
    },
    data() {
      return {
        activeIndex: 0,
        currentSwiper: null,
        showMenu: false,
        menuList: ['AI全效输入法', '个人版', '企业版', '下载', '反馈', '联系我们'],
        dialogShow: false,
        messageShow: false
      }
    },
  }
</script>
<style scoped lang="less">
  .MobileIndexPage {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    background: #fff;
    font-family: 微软雅黑, serif;

    .homePageContainer {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;

      .header {
        width: 100%;
        height: 9vw;
        padding: 1vw;
        margin: 0 auto;
        background-color: white;
        top: 0;
        left: 0;
        box-sizing: border-box;
        position: absolute;
        z-index: 1100;
        display: flex;
        justify-content: space-between;

        .logo {
          cursor: pointer;
          display: flex;
          width: 25vw;
          height: 7vw;
          line-height: 46px;
          padding-left: 1vw;
          font-size: 24px;
          color: #424242;

          img {
            height: 100%;
            margin-right: 10px;
          }
        }

        .flexDiv {
          .menu {
            width: 100%;
            margin-left: 1vw;
            cursor: pointer;
            display: flex;

            img {
              width: 3.8vw;
              margin: 1.6vw;
            }

            span {
              flex: 1;
              line-height: 7vw;
              font-size: 15px;
            }
          }
        }

        .rightLogo {
          display: flex;

          img {
            flex: 1;
            height: 7vw;
            display: block;
            -webkit-filter: grayscale(100%);
            -o-filter: grayscale(100%);
            -moz-filter: grayscale(100%);

          }

          img:hover {
            -webkit-filter: grayscale(0);
            -o-filter: grayscale(0);
            -moz-filter: grayscale(0);
          }
        }
      }

      .CarouselContainer {
        width: 100vw;
        height: 100vh;
        padding-top: 9vw;
        padding-bottom: 20px;
        box-sizing: border-box;
        /*overflow: hidden;*/

        .swiper {
          width: 100vw;

          .swiper-wrapper {
            width: 100vw;

            .swiper-slide {
              width: 100vw;
              height: 100vh;
              position: relative;
            }
          }
        }

        .sliderPage {
          width: 100vw;
          margin: 0 auto;
          position: absolute;
          top: 2vw;
          left: 0;

          .title2 {
            font-size: 32px;
            font-weight: bolder;
            line-height: 50px;
            margin-bottom: 10px;
            color: rgb(230, 0, 18);
            padding-left: 40px;
          }

          .textBody {
            color: rgb(85, 85, 85);
            padding: 20px 40px;
            box-sizing: border-box;

            .title1 {
              font-size: 40px;
              font-weight: bolder;
              line-height: 50px;
              margin-bottom: 10px;
            }

            .title {
              font-size: 32px;
              font-weight: bolder;
              line-height: 36px;
              margin-bottom: 10px;
            }

            .content {
              font-size: 16px;
              line-height: 20px;
              text-align: left;
              color: #868686;
              letter-spacing: 2px;

              a {
                color: #3F95E5;
              }
            }
          }

          .imageBody {
            margin-top: 2vw;

            img {
              display: block;
              width: 80vw;
              height: auto;
              margin: 0 auto;
              border-radius: 10px;
            }
          }

          .button {
            width: 80vw;
            height: 60px;
            border-radius: 4px;
            text-align: left;
            line-height: 60px;
            font-size: 6vw;
            cursor: pointer;
            user-select: none;
            color: white;
            margin: 20px auto;
            display: flex;
            padding: 0 6px;
            box-sizing: border-box;

            .icon {
              font-size: 4vw;
              padding-right: 20px;
            }

            img {
              width: 42px;
              height: 42px;
              margin: 9px;
              display: inline-block;
            }

            a {
              flex: 1;
              display: inline-block;
              height: 100%;
              color: white;
              text-decoration: none;
            }

            a:hover {
              text-decoration: none;
            }

            span {
              flex: 1;
            }
          }

          .dialog {
            width: 100vw;
            height: 100vh;
            position: absolute;
            left: 0;
            top: 0;
            background-color: rgba(0, 0, 0, 0.1);

            .dialogBody {
              width: 90vw;
              height: 80vh;
              position: absolute;
              left: 5vw;
              top: 5vh;
              background-color: #fff;

              .closeButton {
                position: absolute;
                top: 1vw;
                right: 1vw;
                width: 32px;
                height: 32px;
                cursor: pointer;

                img {
                  width: 100%;
                }
              }
            }
          }
        }

        .sliderPagePersonal {
          width: 100vw;
          margin: 0 auto;
          box-sizing: border-box;
          color: rgb(85, 85, 85);

          .title2 {
            padding: 0 7vw;
            font-size: 32px;
            font-weight: bolder;
            line-height: 32px;
            margin: 8px 0;
            box-sizing: border-box;
            color: rgb(230, 0, 18);
          }

          .pageContentItem {
            flex: 1;
            padding: 0 2vw;
            box-sizing: border-box;

            .personalImage {
              width: 88%;
              margin: 6px auto 0px;

              img {
                width: 100%;
              }
            }

            .personalText {
              padding: 0 5vw;
              box-sizing: border-box;

              .title {
                font-size: 24px;
                font-weight: bolder;
                line-height: 28px;
                margin-bottom: 4px;
              }

              .content {
                font-size: 16px;
                line-height: 19px;
                text-align: left;
                color: #868686;
                letter-spacing: 2px;

                img {
                  display: inline-block;
                  width: 14px;
                  height: 14px;
                  box-sizing: border-box;
                }

                span {
                  color: #C00000;
                }
              }
            }
          }
        }
      }

      .guide {
        position: fixed;
        bottom: 6vh;
        left: 50vw;
        opacity: 1;
        margin-left: -32px;
        z-index: 1100;
        -webkit-animation: guide 2.5s infinite;
      }

      @keyframes guide {
        0% {
          bottom: 6vh;
        }
        50% {
          bottom: 3vh;
        }
        100% {
          bottom: 6vh;
        }
      }

      .returnTop {
        position: fixed;
        width: 32px;
        height: 32px;
        top: 60vh;
        right: 20px;
        z-index: 1110;

        img {
          width: 100%;
        }
      }

      .navTabList {
        position: fixed;
        width: 40vw;
        height: 210px;
        top: 11vw;
        right: 1vw;
        z-index: 1110;
        background-color: white;
        border: 1px solid #ddd;
        border-radius: 10px;
        overflow: hidden;

        .navTabItem {
          width: 100%;
          height: 35px;
          line-height: 35px;
          padding: 0 20px;
          box-sizing: border-box;
          background-color: #f9f9f9;
          border-bottom: 0.5px solid #f1f1f1;
          font-size: 16px;
        }

        .navTabItemActive {
          background-color: dodgerblue;
          color: white;
        }

        .navTabItemSecond {
          padding-left: 0px;
        }
      }

      .messageDialog {
        position: fixed;
        width: 74vw;
        height: 60vw;
        top: 23vw;
        left: 13vw;
        z-index: 1110;
        color: dodgerblue;
        text-align: center;
        font-size: 28px;
        background-color: #fff;
        padding: calc(35vw - 60px) 0;
        box-sizing: border-box;
        border-radius: 10px;

        span {
          font-size: 20px;
        }
      }

      .pageBottomBody {
        width: 100vw;
        height: 24px;
        bottom: 0;
        left: 0;
        box-sizing: border-box;
        position: absolute;
        line-height: 24px;
        color: #282828;
        text-align: center;
        background-color: #fff;
        clear: both;
        overflow: hidden;
        z-index: 1100;

        a {
          color: #282828;
          padding: 0 10px;
          text-decoration: none;
        }
      }
    }

  }
</style>
